import { MobXProviderContext } from "mobx-react"
import React from "react"

import { StoreContext } from "./StoresProvider"

export * from "./cartStore"
export * from "./StoresProvider"

export const useStores = () => React.useContext(MobXProviderContext) as StoreContext
